import React, { useContext, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { MyContext } from "../../context/MyContext";

const NavBarSearchMobile = () => {
  const { getSearchItem, search, serchItem, setSearchItem } =
    useContext(MyContext);
  const navigate = useNavigate();

  useEffect(() => {
    getSearchItem(serchItem);
  }, [serchItem]);
  console.log(serchItem);

  useEffect(() => {
    if (serchItem) {
      navigate("/product-search");
    } else {
      navigate("/");
    }
  }, [serchItem]);
  // console.log("search ---->", search);
  return (
    <div className="sticky pt-20 max-sm:top-[-16px] w-full bg-white border border-blue-100 lg:hidden z-50">
      <div className="pt-[25px]">
        <div className="flex items-center justify-between px-4 border-2 rounded-md">
          {/* Search Input */}
          <input
            type="text"
            placeholder="Search products..."
            value={serchItem}
            onChange={(e) => setSearchItem(e.target.value)}
            className="w-full bg-white text-black px-4 py-2 rounded-lg focus:outline-none"
          />

          {/* Search Button */}
          <button
            className="text-purple-500 ml-2 "
            onClick={() => navigate("/product-search")}
          >
            <FaSearch size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NavBarSearchMobile;
